module.exports = __webpack_public_path__ + "static/hero-image-december-f4f19f97125dcd517e1c73fd45e2615f.png";